/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_Mic_TranscribingInputs */

const en_us2_coach_mic_transcribing = /** @type {(inputs: Coach_Mic_TranscribingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transcribing…`)
};

const pt_br2_coach_mic_transcribing = /** @type {(inputs: Coach_Mic_TranscribingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transcrevendo…`)
};

const es_419_coach_mic_transcribing = /** @type {(inputs: Coach_Mic_TranscribingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transcribiendo…`)
};

const pt_pt2_coach_mic_transcribing = /** @type {(inputs: Coach_Mic_TranscribingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A transcrever…`)
};

const fr_fr2_coach_mic_transcribing = /** @type {(inputs: Coach_Mic_TranscribingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transcription…`)
};

const de_de2_coach_mic_transcribing = /** @type {(inputs: Coach_Mic_TranscribingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wird umgewandelt…`)
};

const it_it2_coach_mic_transcribing = /** @type {(inputs: Coach_Mic_TranscribingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trascrizione…`)
};

/**
* | output |
* | --- |
* | "Transcribing…" |
*
* @param {Coach_Mic_TranscribingInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coach_mic_transcribing = /** @type {((inputs?: Coach_Mic_TranscribingInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Mic_TranscribingInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coach_mic_transcribing(inputs)
	if (locale === "es-419") return es_419_coach_mic_transcribing(inputs)
	if (locale === "pt-PT") return pt_pt2_coach_mic_transcribing(inputs)
	if (locale === "fr-FR") return fr_fr2_coach_mic_transcribing(inputs)
	if (locale === "de-DE") return de_de2_coach_mic_transcribing(inputs)
	if (locale === "it-IT") return it_it2_coach_mic_transcribing(inputs)
	return en_us2_coach_mic_transcribing(inputs)
});
export { coach_mic_transcribing as "coach-mic.transcribing" }